import { render, staticRenderFns } from "./TimelineEmail.vue?vue&type=template&id=67b8ccf0&scoped=true&"
import script from "./TimelineEmail.vue?vue&type=script&lang=js&"
export * from "./TimelineEmail.vue?vue&type=script&lang=js&"
import style0 from "./TimelineEmail.vue?vue&type=style&index=0&id=67b8ccf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b8ccf0",
  null
  
)

export default component.exports